<template>
    <div class="page-search show-results" id="page-search">
        <div class="page-search__top">
            <div class="container">
                <div class="wrapper">
                    <div id="search-filter" class="search-bar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                            <path fill-rule="evenodd"
                                  d="M7.2 12.439c2.95 0 5.35-2.385 5.35-5.316 0-2.93-2.4-5.315-5.35-5.315-2.95 0-5.35 2.384-5.35 5.315 0 2.931 2.4 5.316 5.35 5.316M7.2 0c3.97 0 7.2 3.195 7.2 7.123 0 1.65-.571 3.17-1.527 4.38l6.827 6.766a1 1 0 0 1-.01 1.438 1.049 1.049 0 0 1-.73.293c-.27 0-.538-.1-.741-.303l-6.84-6.778A7.213 7.213 0 0 1 7.2 14.247c-3.97 0-7.2-3.196-7.2-7.124C0 3.195 3.23 0 7.2 0"/>
                        </svg>
                        <input class="search" id="search-site" v-model="searchInput" name="s" type="text"
                               placeholder="Waar ben je naar op zoek?" autocomplete="off">
                        <div class="search-loader"></div>
                    </div>
                    <a class="close-search-form" id="close-search-form" href="#">
                        <svg class="icon-close-big" width="14" height="14" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.645 11.932a1.212 1.212 0 0 1-1.713 1.713L7 8.713l-4.932 4.932a1.207 1.207 0 0 1-1.713 0 1.212 1.212 0 0 1 0-1.713L5.287 7 .355 2.068A1.212 1.212 0 0 1 2.068.355L7 5.287 11.932.355a1.212 1.212 0 0 1 1.713 1.713L8.713 7l4.932 4.932z"
                                  fill-rule="evenodd"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <div class="page-search__results">
            <div class="container">
                <p class="results-for none" v-if="searchInput">Zoekresultaten voor <span id="search-term-display">'{{ searchInput }}'</span></p>
                <div class="row search-cols">
                    <div :class="{ 'loader--loading' : loading }" class="loader">
                        <img v-if="loaderSvg" :src="loaderSvg" alt=""/>
                    </div>
                    <template v-for="group in groups" :key="group.key">
                        <div v-if="bucketHasResults(group.key)" class="col-lg-4 col-md-6 search-col" :style="{ order: group.order }">
                            <div class="search-cols__item">
                                <div class="top">
                                    <h4>{{ group.label }}</h4>
                                    <div class="count">
                                        <span v-if="bucket(group.key).length > 10 && !showAll[group.key]">10+</span>
                                        <span v-else>{{ bucket(group.key).length }}</span>
                                    </div>
                                </div>
                                <ul :class="{ toggle: showAll[group.key] }">
                                    <li v-for="(item, index) in bucket(group.key)" :key="item.id">
                                        <a :href="item.link" @click="trackResultClick(group.key, item, index)">{{ item.question || item.title }}</a>
                                    </li>
                                </ul>
                                <div class="toggle-items" :class="{ toggled: showAll[group.key] }"
                                     @click="toggleShowAll(group.key)"
                                     v-if="bucket(group.key).length > 10">
                                    {{ showAll[group.key] ? 'Bekijk minder resultaten' : 'Bekijk meer resultaten' }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-if="searchInput" class="col-lg-4 col-md-6 shop-col" :class="{ 'shop-col--hidden' : loading }">
                        <div class="search-cols__item">
                            <a :href="shopSearchUrl" class="shop-results" target="_blank" @click="trackShopClick">
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path fill="#FFFFFF" fill-rule="evenodd"
                                              d="M17.5111 19.2288H7.48584V9.75732h1.11429v1.28718c0 .4103.33261.7429.74285.7429.41025 0 .74282-.3326.74282-.7429V9.75732h4.8286v1.28718c0 .4103.3326.7429.7429.7429.4102 0 .7428-.3326.7428-.7429V9.75732h1.1141l-.0031 9.47148ZM10.0859 7.93244c0-1.34903 1.114-2.4466 2.3748-2.4466h.0791c1.261 0 2.3747 1.09757 2.3747 2.4466v.33911h-4.8286v-.33911Zm8.6966.57095c-.1393-.13929-.3283-.23196-.5254-.23196H16.4v-.33912C16.4 5.7641 14.6197 4 12.5396 4h-.0792C10.3803 4 8.6 5.7641 8.6 7.93231v.33912H6.74286c-.41025 0-.74286.3614-.74286.77164V19.9714c0 .4103.33261.7429.74286.7429H18.2536c.4101 0 .7427-.3324.7429-.7427L19 9.0362c.0002-.19704-.0782-.39334-.2175-.53281Z"
                                              clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                                <h3>Zoek in onze shop</h3>
                                <p>Op zoek naar <strong>'{{searchInput}}'</strong> producten in onze shop?</p>
                                <div class="arrow">
                                    <svg class="arrow-icon arrow-icon--left" xmlns="http://www.w3.org/2000/svg" width="15" height="12" fill="none" viewBox="0 0 15 12">
                                        <path fill="#F37362" fill-rule="evenodd"
                                              d="M14.7695 6.28125 9.84852 11.2155c-.15415.1545-.35665.2319-.55895.2319-.20171 0-.40342-.0768-.55757-.2305-.30868-.3079-.30928-.8077-.00138-1.1164l3.57748-3.58734H.789476C.353488 6.51316 0 6.15967 0 5.72368c0-.43599.353488-.78948.789476-.78948H12.3081L8.73062 1.34702c-.3079-.30869-.3073-.808621.00138-1.116517.30869-.3078956.80862-.3073035 1.11652.001579L14.7695 5.16631c.3073.30809.3073.80665 0 1.11494Z"
                                              clip-rule="evenodd"/>
                                    </svg>
                                    <svg class="arrow-icon arrow-icon--right" xmlns="http://www.w3.org/2000/svg" width="15" height="12" fill="none" viewBox="0 0 15 12">
                                        <path fill="#F37362" fill-rule="evenodd"
                                              d="M14.7695 6.28125 9.84852 11.2155c-.15415.1545-.35665.2319-.55895.2319-.20171 0-.40342-.0768-.55757-.2305-.30868-.3079-.30928-.8077-.00138-1.1164l3.57748-3.58734H.789476C.353488 6.51316 0 6.15967 0 5.72368c0-.43599.353488-.78948.789476-.78948H12.3081L8.73062 1.34702c-.3079-.30869-.3073-.808621.00138-1.116517.30869-.3078956.80862-.3073035 1.11652.001579L14.7695 5.16631c.3073.30809.3073.80665 0 1.11494Z"
                                              clip-rule="evenodd"/>
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    const GROUPS = [
        { key: 'oplossingen', label: 'Oplossingen', order: 1 },
        { key: 'inspiratie',  label: 'Inspiratie',  order: 2 },
        { key: 'ervaringen',  label: 'Ervaringen',  order: 3 },
        { key: 'faq',         label: 'Veelgestelde vragen', order: 4 },
    ];
    const BUCKET_KEYS = GROUPS.map(g => g.key);
    const emptyResults = () => Object.fromEntries(BUCKET_KEYS.map(k => [k, []]));
    const emptyShowAll = () => Object.fromEntries(BUCKET_KEYS.map(k => [k, false]));

    export default {
        data() {
            return {
                searchInput: '',
                groups: GROUPS,
                results: emptyResults(),
                showAll: emptyShowAll(),
                loading: false,
                timer: null,
                abortController: null,
                loaderSvg: '',
                lastQuery: '',
            };
        },

        mounted() {
            const mount = document.getElementById('search');
            this.loaderSvg = mount?.dataset?.loaderSvg || '';
        },

        computed: {
            shopSearchUrl() {
                return 'https://shop.derolfgroep.nl/search/?search_term=' + encodeURIComponent(this.searchInput);
            },
        },

        watch: {
            searchInput(value) {
                this.resetResults();
                clearTimeout(this.timer);
                if (this.abortController) this.abortController.abort();
                if (value.length > 2) {
                    this.loading = true;
                    this.timer = setTimeout(() => this.runSearch(value), 400);
                } else {
                    this.loading = false;
                }
            },
        },

        methods: {
            resetResults() {
                this.results = emptyResults();
                this.showAll = emptyShowAll();
            },

            runSearch(q) {
                const controller = new AbortController();
                this.abortController = controller;
                const url = window.location.origin + '/wp-json/rolf/v1/search?q=' + encodeURIComponent(q);
                axios.get(url, { signal: controller.signal })
                    .then(response => {
                        if (controller.signal.aborted) return;
                        const buckets = (response.data && response.data.buckets) || {};
                        this.results = Object.fromEntries(
                            BUCKET_KEYS.map(k => [k, buckets[k] || []])
                        );
                        this.lastQuery = q;
                    })
                    .catch(err => {
                        if (axios.isCancel && axios.isCancel(err)) return;
                        if (err && err.name === 'CanceledError') return;
                        console.error('rolf search failed', err);
                        this.resetResults();
                    })
                    .finally(() => {
                        if (controller.signal.aborted) return;
                        this.loading = false;
                    });
            },

            bucket(key) {
                return this.results[key] || [];
            },

            bucketHasResults(key) {
                return this.bucket(key).length > 0;
            },

            toggleShowAll(key) {
                this.showAll[key] = !this.showAll[key];
            },

            pushAnalytics(payload) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(payload);
            },

            trackResultClick(bucket, item, index) {
                this.pushAnalytics({
                    event: 'search_result_click',
                    search_term: this.lastQuery || this.searchInput,
                    result_type: bucket,
                    result_position: index + 1,
                    result_id: String(item.id),
                    result_url: item.link,
                });
            },

            trackShopClick() {
                this.pushAnalytics({
                    event: 'search_result_click',
                    search_term: this.searchInput,
                    result_type: 'shop_redirect',
                    result_position: 0,
                    result_id: 'shop',
                    result_url: this.shopSearchUrl,
                });
            },
        },
    };
</script>
